import * as types from './types'
import http from '@/Plugins/api'

export default {
  setPager({ commit }, data) {
    commit(types.SET_PAGER, data)
  },
  setChecked({ commit }, data) {
    commit(types.SET_CHECKED, data)
  },
  setOrganizationData({ commit }, data) {
    commit(types.SET_ORGANIZATION_DATA, data)
  },
  resetOrganization({ commit }) {
    commit(types.RESET_ORGANIZATION)
  },
  examineOrganization({ commit }, data) {
    commit(types.EXAMINE_ORGANIZATION, data)
  },
  async getTags({ commit }, term) {
    const r = await http.get(`v2/organizations/tags`)
    commit(types.SET_TAGS, r.data.data)
    return r.data.data
  },
  async getOrganizations({ commit }, searchOptions) {
    const r = await http.get(`v2/organizations`, {
      params: searchOptions,
    })
    commit(types.SET_ORGANIZATIONS, r.data.data)
    return r.data.data
  },
  async getOrganization({ commit }, id) {
    const r = await http.get(`v2/organizations/edit/${id}`)
    commit(types.SET_ORGANIZATION, r.data.data)
    return r.data.data
  },
  async getOrganizationHighlight({ commit }, id) {
    const r = await http.get(`v2/organizations/highlight/${id}`)
    commit(types.SET_ORGANIZATION, r.data.data)
    return r.data.data
  },
  async findOrganizations({ commit }, term) {
    const r = await http.get(`v2/organizations/search?term=${term}`)
    commit(types.SET_FOUND_ORGANIZATIONS, r.data.data)
    return r.data.data
  },
  async saveOrganization({ commit }, data) {
    let r = null
    if (data.id === null) {
      r = await http.post('v2/organizations', data)
    } else {
      r = await http.post('v2/organizations/update', data)
    }
    return r.data.data
  },
  async removeOrganization({ commit }, id) {
    const r = await http.delete(`v2/organizations/${id}`)
    return r.data.data
  },
  async saveUserOrganization({ commit }, data) {
    const r = await http.post(`v2/organizations/saveUserOrganization`, data)
    return r.data.data
  },
  async removeUserOrganization({ commit }, data) {
    const r = await http.post(`v2/organizations/removeUserOrganization`, data)
    return r.data.data
  },
  async generateNewDeepLink({ commit }, data) {
    const r = await http.get(`v2/organizations/generateNewDeepLink/${data}`)
    commit(types.SET_ORGANIZATION_DATA, {
      name: 'deeplinkShort',
      value: r.data.data,
    })
    return r.data.data
  },
  async saveEmails({ commit }, data) {
    const r = await http.post(`v2/settings/saveEmails`, data)
    return r.data.data
  },
  async getMembers({ commit }, data) {
    const r = await http.get(`v2/organizations/members`, {
      params: data,
    })
    commit(types.SET_MEMBERS, r.data.data)
    return r.data.data
  },
  async findMembers({ commit }, term) {
    const r = await http.get(`v2/organizations/searchMembers?term=${term}`)
    commit(types.SET_FOUND_MEMBERS, r.data.data)
    return r.data.data
  },
  sortMembers({ commit }, sort) {
    commit(types.SORT_MEMBERS, sort)
  },
  async addMember({ commit }, data) {
    const r = await http.post(`v2/organizations/addMember`, data)
    return r.data.data
  },
  async removeMember({ commit }, data) {
    const r = await http.post(`v2/organizations/removeMember`, data)
    return r.data.data
  },
  async saveLibraryName({ commit }, data) {
    const r = await http.post(`v2/organizations/saveLibraryName`, data)
    commit(types.SET_LIBRARYNAME, r.data.data)
    return r.data.data
  },
  async saveChallengeName({ commit }, data) {
    const r = await http.post(`v2/organizations/saveChallengeName`, data)
    commit(types.SET_CHALLENGENAME, r.data.data)
    return r.data.data
  },
  async saveDashboardName({ commit }, data) {
    const r = await http.post(`v2/organizations/saveDashboardName`, data)
    commit(types.SET_DASHBOARDNAME, r.data.data)
    return r.data.data
  },
}
